<template>
  <div id="app">
	  <div id="logo">
      <router-link to="/">
        <img src="img/logo.png" alt="The Armed logo" />
      </router-link>
    </div>	
	  <div id="mobileNavTrigger">			
      <ul class="navMenu">			
        <li><a @click="toggle_visibility();">Menu</a></li>
      </ul>
	  </div>		
	  <div id="mobileNav">		
		  <a class="close" @click="toggle_visibility();">X</a>		
      <ul class="navMenu navMobile">          
        <li><a href="/store" target="_blank">Store</a></li>
        <li><router-link to="/social">Social</router-link></li>
        <li><router-link to="/listen">Listen</router-link></li>
        <li><router-link to="/tour">Tour</router-link></li>
        <li>
          <a href="https://discord.gg/FNXdeR58Ff" target="_blank">DISCORD</a>
        </li>
      </ul>		
    </div>	
    <div id="nav">		
      <ul class="navMenu">
        <li><a href="/store" target="_blank">Store</a></li>
        <li><router-link to="/social">Social</router-link></li>
        <li><router-link to="/listen">Listen</router-link></li>
        <li><router-link to="/tour">Tour</router-link></li>
        <li>
          <a href="https://discord.gg/FNXdeR58Ff" target="_blank">DISCORD</a>
        </li>
      </ul>
    </div>
    <div id="content-wrap">	
      <div id="content" class="content">	
        <transition name="fade" mode="out-in">>
          <router-view/>
        </transition>
      </div>
    </div>    
    <video playsinline autoplay muted loop poster="img/background.jpeg" id="loop">
      <source src="video/loop.mp4" type="video/mp4">
    </video>	
  </div>

</template>

<script>
export default {
  name: 'App',
  mounted: function() {
  },
  methods: {
    toggle_visibility: function () {
       var e = document.getElementById('mobileNav');
       if(e.style.display == 'flex')
          e.style.display = 'none';
       else
          e.style.display = 'flex';
    },
    close_mobile: function() {
      var e = document.getElementById('mobileNav');
      e.style.display = 'none';
    }
  }
}
</script>
